import * as React from 'react';
import styled from 'styled-components';

import {Center,Box,Button,Text,useDisclosure,Image} from '@chakra-ui/react';
import { LoadingModal } from '../components/modal/loadingModalComponent';

type Props = {
  defaultValue:string,
  // onClick:(event: React.MouseEvent<HTMLButtonElement>) =>void,

  switchToNFTRecievePageVoid:any,
  onChange:any,
  inputId: string,
  disable:boolean,
  // valueText:string,
}
export const AddressInputButton: React.FC<Props> = (props) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const AddressInputComponent =  styled.div`
    display: flex;
    height: 39px;
    border-radius: 8px 0 0 8px;
  `;
  const AddressInputFieldComponent =  styled.input`
    display: flex;
    border: 1px solid #FFB16A;
    border-radius: 8px 0 0 8px;
    width: 210px;
    height: 39px;

    margin: 0;
    font-family: inherit;
    font-size: inherit;
    line-height: inherit;
    box-sizing: border-box;
    color: black;
 `;
  const NextButtonComponent =  styled.button`
    border: 1px solid #FFB16A;
    width: 40px;
    height: 39px;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 4px;
    background: #FFB16A;
    border-bottom-right-radius: 6px;
    border-top-right-radius: 6px;
  `;
  const NextButtonImageComponent = styled.img`
    width: 30px;
  `;

  return (
    <>
      <AddressInputComponent>
          <AddressInputFieldComponent 
            type='text' 
            id={props.inputId} 
            onChange={props.onChange}
            defaultValue={props.defaultValue}
          />
          <NextButtonComponent 
            disabled={props.disable}
            id={`btn-input-wallet-address`}  
            onClick={async()=>{
              onOpen();
              await props.switchToNFTRecievePageVoid();
            }} 
          >
            <NextButtonImageComponent src='https://nfttopshot-template.onrender.com/template-images/nextbtn.png'/>
          </NextButtonComponent>
      </AddressInputComponent>
    
      <LoadingModal 
        isOpen={isOpen} 
        onClose={onClose} 
      />
    </>
  );
};